/* Tonic Home V2: shared behaviour for the th-* sections. */
(() => {
  const reveal = (root) => {
    const items = root.querySelectorAll('[data-th-reveal]:not(.is-in)');
    if (!items.length) return;
    if (window.Shopify && Shopify.designMode || !('IntersectionObserver' in window)) {
      items.forEach((el) => el.classList.add('is-in'));
      return;
    }
    const io = new IntersectionObserver((entries) => entries.forEach((entry) => {
      if (!entry.isIntersecting) return;
      entry.target.classList.add('is-in');
      io.unobserve(entry.target);
    }), { threshold: 0.12, rootMargin: '0px 0px -40px 0px' });
    items.forEach((el) => io.observe(el));
  };

  /* A scrolling product row with arrow buttons and optional product type tabs. */
  class ThRail extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('.th-rail__track');
      this.prev = this.querySelector('[data-th-dir="-1"]');
      this.next = this.querySelector('[data-th-dir="1"]');
      this.limit = parseInt(this.dataset.limit, 10) || 0;
      this.querySelectorAll('[data-th-dir]').forEach((btn) => btn.addEventListener('click', () => {
        const behavior = matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth';
        this.track.scrollBy({ left: +btn.dataset.thDir * this.track.clientWidth * 0.8, behavior });
      }));
      this.track.addEventListener('scroll', () => this.updateButtons(), { passive: true });
      const tabs = this.closest('.shopify-section').querySelector('.th-tabs');
      if (tabs) tabs.addEventListener('click', (event) => {
        const tab = event.target.closest('.th-tab');
        if (tab) this.filter(tab);
      });
      this.filter(tabs && tabs.querySelector('.th-tab[aria-selected="true"]'));
    }

    filter(tab) {
      if (tab) tab.parentElement.querySelectorAll('.th-tab').forEach((t) => t.setAttribute('aria-selected', t === tab));
      const types = tab && tab.dataset.types ? tab.dataset.types.split(',').map((t) => t.trim().toLowerCase()).filter(Boolean) : [];
      let shown = 0;
      this.track.querySelectorAll(':scope > li').forEach((li) => {
        const match = !types.length || types.includes(li.dataset.type);
        const show = match && (types.length || !this.limit || shown < this.limit);
        li.hidden = !show;
        if (show) shown += 1;
      });
      const empty = this.querySelector('.th-rail__empty');
      if (empty) empty.hidden = shown > 0;
      this.track.scrollLeft = 0;
      this.updateButtons();
    }

    updateButtons() {
      if (!this.prev) return;
      const max = this.track.scrollWidth - this.track.clientWidth - 2;
      this.prev.disabled = this.track.scrollLeft <= 2;
      this.next.disabled = this.track.scrollLeft >= max;
    }
  }
  if (!customElements.get('th-rail')) customElements.define('th-rail', ThRail);

  /* Numbers marked data-th-count="76" count up from 0 the first time they scroll into view.
     The final number is already in the HTML, so it shows without JavaScript or with reduced motion. */
  const countUp = (root) => {
    const items = root.querySelectorAll('[data-th-count]:not(.is-counted)');
    if (!items.length || !('IntersectionObserver' in window) || matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    const io = new IntersectionObserver((entries) => entries.forEach((entry) => {
      if (!entry.isIntersecting) return;
      io.unobserve(entry.target);
      const el = entry.target;
      const to = parseFloat(el.dataset.thCount);
      const pre = el.dataset.thPrefix || '';
      const suf = el.dataset.thSuffix || '';
      const t0 = performance.now();
      const step = (now) => {
        const p = Math.min(1, (now - t0) / 1200);
        el.textContent = pre + Math.round(to * (1 - Math.pow(1 - p, 3))).toLocaleString('en-AU') + suf;
        if (p < 1) requestAnimationFrame(step);
      };
      requestAnimationFrame(step);
    }), { threshold: 0.4 });
    items.forEach((el) => { el.classList.add('is-counted'); io.observe(el); });
  };

  const start = () => { reveal(document); countUp(document); };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
  document.addEventListener('shopify:section:load', (event) => { reveal(event.target); countUp(event.target); });
})();
